import React from 'react';
import {useSpring, animated } from 'react-spring'
import styled from 'styled-components';

import {  colorPalette } from "../Config/colorConfig.js"

import ImageGallery from "react-image-gallery"; 
import "../Config/image-gallery.css";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
import { faCaretUp } from '@fortawesome/free-solid-svg-icons'

import {thumbnailPath1Config,
        thumbnailPath2Config,
        } from "../Config/naviConfig.js"

//path shift
//const thumbnailConfig = thumbnailPath1Config
const thumbnailConfig = thumbnailPath2Config

const NaviSlideWrapper = styled(animated.div)`  
    cursor:'pointer';    
    position:fixed;
    bottom:0;
    width:100%;
    background: #333;
    z-index:200;
`;

const NaviSlideButton = styled.button`
    cursor:'pointer';
    display: flex;
    align-items: center; 
    justify-content: center; 
    position:absolute;
    width:100px;
    height:20px;
    right: calc(50% - 50px);
    bottom:100%;
    color: #FFF;
    background-color: ${colorPalette.myBlue};
    border:none;
    border-radius:5px 5px 0px 0px;
    z-index: 50;
    &:hover {
        transform: scale(1.1);
        border:none;
        outline: none;
    };
    &:active,&:focus,&:visited{
        border:none;
        outline: none;
    }
`;

const NaviSlide=(props)=>{
    
    const{  naviRef,
            naviSlideHide,
            setNaviSlideHide,
            setImgIndex,
            setGoToYaw,
            setGoToPitch,
            setLookAtCard,
            langCh
        } = props
    
    const naviSlideHideProps = useSpring({  bottom: naviSlideHide?`-${naviRef.current.clientHeight}px`:'0px', 
                                            config: {  mass: 1, tension: 200, friction: 40 }
                                        })

    return(
        <NaviSlideWrapper ref={naviRef} style={naviSlideHideProps} >
            <NaviSlideButton onClick={()=>setNaviSlideHide(!naviSlideHide)} >
                {!naviSlideHide&&<FontAwesomeIcon icon={faCaretDown} size='2x'/>}
                { naviSlideHide&&<FontAwesomeIcon icon={faCaretUp  } size='2x'/>}
            </NaviSlideButton>
            <ImageGallery
                items={thumbnailConfig(langCh)}  
                showNav={true}
                onThumbnailClick ={(_ , index) => { setLookAtCard(false);
                                                    setImgIndex(thumbnailConfig()[index].args[0]);
                                                    setGoToYaw(thumbnailConfig()[index].args[1]);
                                                    setGoToPitch(thumbnailConfig()[index].args[2]);
                                    }}
                showFullscreenButton={false}
                showPlayButton={false}
                autoPlay={false}
                infinite={true}
                slideDuration={0}
                slideInterval={0}
                lazyLoad={true}
                disableThumbnailScroll={false}
                disableSwipe={false}
                disableKeyDown={true}//無法用鍵盤滑navi
                slideOnThumbnailOver={true}
            />
        </NaviSlideWrapper>
    )
}

export default NaviSlide;